import { random } from "tinycolor2";

export const getRandomDarkColor = () => {
  while (true) {
    const color = random();
    if (color.getBrightness() < 180) return color.toHexString();
  }
};
